const router = [
  {
    path: "/home",
    meta: {
      title: "首页",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/index"], resolve),
  },
  {
    path: "/memberCompany",
    meta: {
      title: "会员企业",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/memberCompany/index"], resolve),
  },
  {
    path: "/dataService",
    meta: {
      title: "数据服务",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/dataService"], resolve),
  },
  {
    path: "/qualityService",
    meta: {
      title: "品控服务",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/qualityService"], resolve),
  },
  {
    path: "/materialService",
    meta: {
      title: "物流服务",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/materialService"], resolve),
  },
  {
    path: "/financeService",
    meta: {
      title: "金融服务",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/financeService"], resolve),
  },
  {
    path: "/harborService",
    meta: {
      title: "清关服务",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/harborService"], resolve),
  },
  {
    path: "/intro",
    meta: {
      title: "公司介绍",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/intro"], resolve),
  },
  {
    path: "/service",
    meta: {
      title: "仓储中心",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/service/index"], resolve),
  },
  {
    path: "/service/detail",
    meta: {
      title: "仓储中心详情",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/service/detail"], resolve),
  },
  {
    path: "/newsNew",
    meta: {
      title: "新闻中心",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/newsNew/index"], resolve),
  },
  {
    path: "/newsNew/detail",
    meta: {
      title: "新闻中心详情",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/newsNew/detail"], resolve),
  },
  {
    path: "/ruleDetail",
    meta: {
      title: "整体规则汇总试用",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/rules/ruleDetail"], resolve),
  },
  {
    path: "/rules",
    meta: {
      title: "规则中心",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/rules/index"], resolve),
  },
  {
    path: "/contactUs",
    meta: {
      title: "联系我们",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/contactUs/index"], resolve),
  },
  {
    path: "/tradeCenter",
    meta: {
      title: "交易平台",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/tradeCenter/index"], resolve),
  },
  {
    path: "/tradeCenter/list",
    meta: {
      title: "交易平台",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/tradeCenter/list"], resolve),
  },
  {
    path: "/tradeCenter/result",
    meta: {
      title: "搜索结果",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/tradeCenter/result"], resolve),
  },
  {
    path: "/delivery",
    meta: {
      title: "交割中心",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/delivery/index"], resolve),
  },
  {
    path: "/delivery/detail",
    meta: {
      title: "交割中心",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/delivery/detail"], resolve),
  },
  {
    path: "/agreement/agreement",
    meta: {
      title: "隐私协议",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/agreement/agreement"], resolve),
  },
  {
    path: "/agreement/service",
    meta: {
      title: "服务协议",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/agreement/service"], resolve),
  },
  {
    path: "/special",
    meta: {
      title: "专场",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/special/index"], resolve),
  },
  {
    path: "/overseas",
    meta: {
      title: "海外专区",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/overseas/index"], resolve),
  },
  {
    path: "/overseas/detail",
    meta: {
      title: "海外专区-详情",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/overseas/detail"], resolve),
  },
  {
    path: "/finishedProduct",
    meta: {
      title: "成品专区",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/finishedProduct/index"], resolve),
  },
  {
    path: "/finishedProduct/detail",
    meta: {
      title: "成品专区-详情",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/finishedProduct/detail"], resolve),
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/router/home.js